
/**
 * JavaScript React Framework
 */
import React from 'react';

/**
 * React-Bootstrap
 */ 
import { Panel, PageHeader } from 'react-bootstrap';

/**
 * Cascading StyleSheets
 */
 import 'bootstrap/dist/css/bootstrap.min.css';
 
/**
 * Note: Your components tell React what you want to render
 */
class MarketingBlock extends React.Component {
	render() {
		return (
			<div>
				<Panel>
					<PageHeader>{this.props.header}</PageHeader>
          <p className="text-justify">
          	{this.props.children}
          </p>
        </Panel>
			</div>
		); // return
	} // render
} // class

/**
 * Expose default class
 */
export default MarketingBlock;



// WEBPACK FOOTER //
// ./src/cba/common/content/MarketingBlock.js